<template>
  <md-card>
    <md-card-header>
      <h2>{{ title }}</h2>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="card-title">Datos del personal</h4>
        </div>
        <form class="md-layout-item" id="customer_staff_form" @submit.prevent="saveCustomerStaff()">
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-medium-size-100">
              <md-field :class="validationClass('name')">
                <label for="name">Nombre</label>
                <md-input
                  data-vv-name="name"
                  v-validate="modelValidations.name"
                  v-model="updatedCostumerStaff.name"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33 md-medium-size-100">
              <md-field :class="validationClass('lastName')">
                <label for="name">Apellido Paterno</label>
                <md-input
                  data-vv-name="lastName"
                  v-validate="modelValidations.lastName"
                  v-model="updatedCostumerStaff.lastName"
                ></md-input>
              </md-field>
            </div>

            <md-field
              :class="validationClass('mothersLastName')"
              class="md-layout-item md-size-33 md-medium-size-100"
            >
              <label for="name">Apellido Materno</label>
              <md-input
                data-vv-name="mothersLastName"
                v-validate="modelValidations.mothersLastName"
                v-model="updatedCostumerStaff.mothersLastName"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout">
            <md-field
              class="md-layout-item md-size-50 md-medium-size-100"
              :class="validationClass('title')"
            >
              <label for="title">Titulo</label>
              <md-input v-model="updatedCostumerStaff.title"></md-input>
            </md-field>

            <div class="md-layout-item md-size-50 md-medium-size-100">
              <md-field :class="validationClass('typeStaff')">
                <label for="type_staff">Tipo de personal</label>
                <md-select
                  data-vv-name="typeStaff"
                  v-validate="modelValidations.typeStaff"
                  v-model="updatedCostumerStaff.typeStaffId"
                >
                  <md-option
                    v-for="customerStaffType in customerStaffTypes"
                    :value="customerStaffType.id"
                    :key="customerStaffType.id"
                  >{{ customerStaffType.name }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <md-field
              class="md-layout-item md-size-50 md-medium-size-100"
              :class="validationClass('email')"
            >
              <label for="email">E-mail</label>
              <md-input v-model="updatedCostumerStaff.email"></md-input>
            </md-field>
            <md-field
              class="md-layout-item md-size-50 md-medium-size-100"
              :class="validationClass('cellphone')"
            >
              <label for="cellphone">Celular</label>
              <md-input v-model="updatedCostumerStaff.cellphone"></md-input>
            </md-field>
          </div>

          <div class="md-layout">
            <md-field
              class="md-layout-item md-size-40 md-medium-size-100"
              :class="validationClass('phone')"
            >
              <label for="phone">Telefono</label>
              <md-input v-model="updatedCostumerStaff.phone"></md-input>
            </md-field>

            <md-field
              class="md-layout-item md-size-20 md-medium-size-100"
              :class="validationClass('phoneExt')"
            >
              <label for="phoneExt">Extension</label>
              <md-input v-model="updatedCostumerStaff.phoneExt"></md-input>
            </md-field>
          </div>
        </form>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button type="submit" form="customer_staff_form" class="md-success">Aceptar</md-button>
      <md-button @click="$emit('close')">Cancelar</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import { mapState } from "vuex";
import catalogService from "@/services/catalog";
import Staff from "./Staff";

const modelValidations = {
  name: {
    required: true,
  },
  lastName: {
    required: true,
  },
  title: {
    required: false,
  },
  mothersLastName: {
    required: true,
  },
  typeStaff: {
    required: true,
  },
  position: {
    required: true,
  },
  phone: {
    required: true,
  },
  phoneExt: {
    required: true,
  },
  cellphone: {
    required: true,
  },
  email: {
    required: true,
  },
};

export default {
  name: "EditCustomerStaff",

  components: {
    Staff,
  },

  props: {
    customerId: Number,
    customerStaff: Object,
    title: {
      type: String,
      default: "Editar personal",
    },
  },

  data() {
    return {
      updatedCostumerStaff: {},
      touched: {
        name: false,
        codename: false,
      },
      modelValidations,
      defaultCustomerStaff: {
        isActive: true,
      },
    };
  },
  methods: {
    saveCustomerStaff() {
      const payload = {
        original: this.customerStaff,
        updated: this.updatedCostumerStaff,
      };
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", payload);
        }
      });
    },
    validationClass(field) {
      return [
        { "md-valid": !this.errors.has(field) && this.touched[field] },
        { "md-error": this.errors.has(field) },
      ];
    },
  },
  mounted() {
    const customerId = this.customerId;
    this.updatedCostumerStaff = {
      customer: customerId,
      customerId,
      ...this.customerStaff,
    };
    this.watchTouched({ updatedCostumerStaff: Object.keys(modelValidations) });
  },
  computed: {
    ...mapState("catalogs", {
      customerStaffTypes: (s) => s["customer/typecustomerstaff"],
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Customers/EditStaff.vue